import { render, staticRenderFns } from "./ForgotPasswordpage.vue?vue&type=template&id=802d794a&"
import script from "./ForgotPasswordpage.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports